const style:any = (): any => ({
	root: {
		display: "flex",
		height:"100%"
	},
	content: {
		flexGrow: 1,
		marginTop: 56,
		height: "calc(100vh - 70px)",
	},
	embedContent: {
		flexGrow: 1,
		height: "calc(100vh - 70px)",
	},

	container:{
		height:"100%"
	},
	subContainer: {
		textAlign:"center" as const,
		padding:"50px 5px",
		marginTop: 80,
		display: "flex" as const,
		alignItems: "center",
		alignContent: "center",
		flexDirection: "column" as const
	},
	description:{
		fontSize:"12px"
	},
	maintenancePage: {
		position: "relative",
		height: "100%"
	},

	maintenancePageContainer: {
		position: "absolute",
		margin: 0,
		top: "40%",
		textAlign: "center",
		width: "100%",
		padding: "1rem",
		boxSizing: "border-box",
		transform: "translateY(-60%)"
	},

	maintenancePageHeading: {
		fontSize: "3rem",
		fontWeight: 500,
		marginTop: "2.5rem",
	},

	maintenancePageContent: {
		fontSize: "1.25rem",
		marginTop: "1.25rem",
		color: "rgb(36, 44, 52)",
	}

});

export default style;